import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import {
    Container,
    Row,
    Col,
    Input,
    Button,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    InputGroup,
    InputGroupAddon,
    Form,
} from 'reactstrap'
import CardColumns from 'reactstrap/lib/CardColumns'
import InfiniteScroll from 'react-infinite-scroll-component'
import classNames from 'classnames'
import { debounce, isEmpty } from 'lodash'

import {
    getPlans,
    resetPlans,
    toggleFavourite,
    toggleLike,
    togglePublic,
} from '../../redux/plan/actions'

import Icon from '../../components/Icons/Icon'
import PlanPreview from '../../components/Plans/PlanPreview/PlanPreview'
import PlanShareModal from '../../components/Plans/PlanShareModal/PlanShareModal'
import Loading from '../../components/Loading/Loading'

import SortIcon from '../../assets/img/icons/SORT.svg'
import SearchIcon from '../../assets/img/icons/SEARCH.svg'

import './index.css'

const Index = (props) => {
    const dispatch = useDispatch()
    const [sort, setSort] = useState(null)
    const [type, setType] = useState(null)
    const [filter, setFilter] = useState(null)

    const plans = useSelector((state) => state.plan.plans)
    const loadingPlans = useSelector((state) => state.plan.loadingPlans)

    const [dropdownOpen, setDropdownOpen] = useState(false)
    const location = useLocation()
    const history = useHistory()
    const [search, setSearch] = useState('')

    useEffect(() => {
        if (type) addQueryString('type', type)
    }, [type])

    const [pageNumber, setPageNumber] = useState(1)

    const fetchData = () => {
        setPageNumber((prevPageNumber) => prevPageNumber + 1)
        dispatch(
            getPlans({
                type: type,
                sort: sort,
                filter: filter,
                search: search,
                pageNumber: pageNumber + 1,
            })
        )
    }

    useEffect(() => {
        let newSort = sort
        let newType = type
        let newFilter = {}

        const params = new URLSearchParams(location.search)
        for (let param of params) {
            const [key, value] = param

            if (key === 'sort') newSort = value
            else if (key === 'type') newType = value
            else if (new RegExp('[0-9]+').test(key)) {
                newFilter = { ...newFilter, [key]: value }
            }
        }

        dispatch(
            getPlans({
                type: newType,
                sort: newSort,
                filter: newFilter,
                pageNumber: 1,
                search: search,
                replace: true,
            })
        )
        setPageNumber(1)
        setSort(newSort)
        setType(newType)
        setFilter(newFilter)
    }, [location])

    const resetPaging = () => {
        setPageNumber(1)
        dispatch(resetPlans())
    }

    const toggle = () => setDropdownOpen((prevState) => !prevState)

    const addQueryString = (key, value) => {
        resetPaging()
        let urlParams = new URLSearchParams(location.search)
        urlParams.set(key, value)
        history.push({ pathname: '/', search: '?' + urlParams.toString() })
    }

    const onLikedPlan = (planId) => {
        dispatch(toggleLike(planId))
    }
    const onFavouritedPlan = (planId) => {
        dispatch(toggleFavourite(planId))
    }
    const onTogglePublic = (planId, newValue) => {
        dispatch(togglePublic(planId, newValue))
    }

    const [isShareVisible, setIsShareVisible] = useState(false)
    const toggleShare = () => setIsShareVisible(!isShareVisible)
    const [currentPlanId, setCurrentPlanId] = useState(null)

    const onShare = (planId) => {
        setCurrentPlanId(planId)
        toggleShare()
    }

    const onSearchChanged = debounce((searchValue) => {
        onSearch(searchValue)
    }, 500)

    const onSearch = (searchValue) => {
        setSearch(searchValue)

        dispatch(
            getPlans({
                type: type,
                sort: sort,
                filter: filter,
                search: searchValue,
                pageNumber: 1,
                replace: true,
            })
        )
    }

    return (
        <Container className="plans">
            <div className="plans__search-wrapper">
                <Form
                    onSubmit={(e) => {
                        e.preventDefault()
                        onSearch()
                    }}
                >
                    <InputGroup className="flex-row-reverse w-50">
                        <InputGroupAddon addonType="prepend">
                            <Button className="plans__search-button">
                                <Icon src={SearchIcon} />
                            </Button>
                        </InputGroupAddon>
                        <Input
                            placeholder="جستجوی طرح ها..."
                            onChange={(e) => onSearchChanged(e.target.value)}
                        />
                    </InputGroup>
                </Form>
            </div>
            <div className="plans__filter-wrapper">
                <div className="text-right">
                    <Icon src={SortIcon} size="lg" />
                    مرتب سازی بر اساس
                    <Button
                        color="link"
                        className={classNames({
                            'is-active': sort === 'popular',
                        })}
                        onClick={() => addQueryString('sort', 'popular')}
                    >
                        محبوب‌ترین ها
                    </Button>
                    <Button
                        color="link"
                        className={classNames({
                            'is-active': sort === 'most-seen',
                        })}
                        onClick={() => addQueryString('sort', 'most-seen')}
                    >
                        پربازدیدترین ها
                    </Button>
                    <Button
                        color="link"
                        className={classNames({
                            'is-active': sort === 'newest',
                        })}
                        onClick={() => addQueryString('sort', 'newest')}
                    >
                        جدید‌ترین ها
                    </Button>
                </div>
                <div className="d-flex align-items-center">
                    نمایش
                    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            {type === 'my' ? 'طرح‌های من' : 'همه'}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => setType('all')}>
                                همه
                            </DropdownItem>
                            <DropdownItem onClick={() => setType('my')}>
                                طرح‌های من
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
            <div className="plans__container">
                <InfiniteScroll
                    dataLength={plans.length} //This is important field to render the next data
                    next={fetchData}
                    hasMore={type !== 'my' && type !== 'favourite'}
                    loader={loadingPlans && <Loading />}
                    endMessage={
                        loadingPlans ? (
                            <Loading />
                        ) : (
                            !isEmpty(plans) &&
                            pageNumber !== 1 && (
                                <p style={{ textAlign: 'center' }}>
                                    <b>تمامی طرح‌ها دیده شد!</b>
                                </p>
                            )
                        )
                    }
                    scrollableTarget={document.querySelector(
                        '.plans__container'
                    )}
                    height={
                        document.querySelector('.plans__container')
                            ?.clientHeight ?? 500
                    }
                >
                    <CardColumns>
                        {isEmpty(plans) && !loadingPlans ? (
                            <p>هیچ طرحی پیدا نشد</p>
                        ) : (
                            plans.map((plan) => (
                                <PlanPreview
                                    key={plan.id}
                                    {...plan}
                                    onLiked={onLikedPlan}
                                    onFavourited={onFavouritedPlan}
                                    onTogglePublic={onTogglePublic}
                                    onShare={onShare}
                                />
                            ))
                        )}
                    </CardColumns>
                </InfiniteScroll>
            </div>
            <PlanShareModal
                toggle={toggleShare}
                visible={isShareVisible}
                planId={currentPlanId}
            />
        </Container>
    )
}

export default Index
